module.exports = __webpack_public_path__ + "img/wx_tips.74a82030.jpg";